var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-td-button-select-b2b"},[_c('MdtButtonSelect',{attrs:{"items":_vm.itemsTransformed,"size":"size-32","relative":""},on:{"buttonSelect":_vm.buttonSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }